import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { DocumentFileTemplateKeyKindEnum } from '@zaoblako/shared/modules/catalog/enums/document-file-template-key-kind.enum';
import { DocumentFileTemplateKeyKindEnumI18n } from '@zaoblako/shared/modules/catalog/i18n/document-file-template-key-kind-enum.i18n';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import type { DocumentFileTemplateKeyBriefFindInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template-key/document-file-template-key-brief-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';

import * as yup from 'yup';

/** Document file template key create/update API request body - DTO signature */
export interface DocumentFileTemplateKeyFormInterface {
  /** Name this document file template key */
  name: string;
  /** Target this document template key (example: `contragent.name`) */
  target: string;
  /** Path this document template key (example: `Контрагент->Название`) */
  path: string;
  /** How the value is resolved */
  kind: DocumentFileTemplateKeyKindEnum;
  /** For {@link DocumentFileTemplateKeyKindEnum.AMOUNT_IN_WORDS}: entity-like reference to the numeric source key */
  sourceKey?: OnlyIdRequiredInterface<DocumentFileTemplateKeyBriefFindInterface>;
  /** User who created this document file template key */
  createdBy?: UserFindInterface;
}

/** Document file template key create/update API request body - DTO schema */
export const DocumentFileTemplateKeyFormDto = SerdeDtoClass.create<DocumentFileTemplateKeyFormInterface>(CatalogDtosKeysEnum.DOCUMENT_FILE_TEMPLATE_KEY_FORM_DTO, {
  name: {
    label: 'Имя',
    serializer: yup.string()
      .transform(value => value ? value.replace(/\s+/g, '') : value)
      .matches(/^[а-яА-Яa-zA-Z0-9._]+$/, 'Разрешены только буквы, цифры, точка и нижнее подчеркивание')
      .test('no-consecutive-special', 'Две точки или два подчеркивания не могут стоять подряд',
        value => !/(\.\.|__)/.test(value),
      ),
  },
  kind: {
    label: 'Тип ключа',
    serializer: commonEnumValidator(DocumentFileTemplateKeyKindEnum, DocumentFileTemplateKeyKindEnumI18n),
  },
  target: {
    optional: ({ value }) => (<DocumentFileTemplateKeyFormInterface>value)?.kind === DocumentFileTemplateKeyKindEnum.AMOUNT_IN_WORDS,
    default: '',
    label: 'Цель',
    hint: 'Путь до желаемого объекта',
    serializer: yup.string(),
  },
  path: {
    optional: ({ value }) => (<DocumentFileTemplateKeyFormInterface>value)?.kind === DocumentFileTemplateKeyKindEnum.AMOUNT_IN_WORDS,
    default: '',
    label: 'Путь',
    hint: 'Визуально понятный текстовый путь до объекта',
    serializer: yup.string(),
  },
  sourceKey: {
    optional: ({ value }) => (<DocumentFileTemplateKeyFormInterface>value)?.kind !== DocumentFileTemplateKeyKindEnum.AMOUNT_IN_WORDS,
    label: 'Ключ',
    hint: 'Числовой ключ: его значение подставляется прописью',
    serializer: entityLikeSchema,
  },
  createdBy: {
    optional: true,
    sortable: true,
    label: 'Пользователь',
    serializer: entityLikeSchema,
  },
});
